import * as React from 'react'
import Content from './content'
import './style.scss'

export interface IProps {
  history: any
}

export interface IState {}

const onScheduleCallClicked = () => {
  const scheduelUrl =
    'https://calendly.com/ori_giantleap/30-min-call-with-ori-zoom'
  window.open(scheduelUrl, '_blank')
}

const onClose = (history: any) => {
  history.replace('/children_list')
}

class CongratulationsPayment extends React.PureComponent<IProps, IState> {
  render() {
    const { history } = this.props
    return (
      <Content
        onScheduleCallClicked={() => onScheduleCallClicked()}
        onClose={() => onClose(history)}
      />
    )
  }
}

export default CongratulationsPayment



// WEBPACK FOOTER //
// ./src/pages/CongratulationsPayment/index.tsx